import React from "react";
import { useTranslation } from "react-i18next";

import { S3 } from "../../../../constants";
import LogoOverlayComponent from "../LogoOverlayComponent";

const PreviewBranding = ({ customBranding = {}, mobile }) => {
  const { t } = useTranslation("dashboard");
  const {
    splashOverlayColor,
    splashOverlayOpacity,
    mobileSplashBg,
    mobileSplashImg,
    tintSplashImg,
  } = customBranding;

  const backgroundImage =
    mobileSplashBg && mobileSplashBg.s3Path
      ? `${S3.PATH}${mobileSplashBg.s3Path}`
      : null;

  return (
    <div className="self-center">
      <div
        className="exercise-phone-image"
        style={mobile && { paddingBlock: "20px", boxSizing: "border-box" }}
      >
        <div className="section phone-template">
          <div
            className="background-container"
            style={{
              backgroundImage: backgroundImage
                ? `url(${backgroundImage})`
                : undefined,
              backgroundColor: "var(--background-color)",
              backgroundSize: "cover",
              backgroundPosition: "center",
              backgroundRepeat: "no-repeat",
            }}
          >
            <LogoOverlayComponent
              opacity={splashOverlayOpacity}
              overlayColor={splashOverlayColor}
              withOverlay={!!splashOverlayColor}
              withLogo
              logo={mobileSplashImg}
              isTinted={tintSplashImg}
            />
          </div>
          <img alt={t("branding.phoneAlt")} src="/img/iphone-template.webp" />
        </div>
      </div>
    </div>
  );
};

export default PreviewBranding;
